import React from 'react';
import { useSelector } from 'react-redux';
import { useGetTasksQuery } from '../features/tasks/tasksApi';
import dateToArr from '../util/dateToArr';
import SingleTask from './SingleTask';

const TaskList = () => {
  const { data: tasks, isLoading, isError } = useGetTasksQuery();
  const { checked } = useSelector((state) => state.projects);
  const { search } = useSelector((state) => state.tasks);

  const filteredTasks = tasks
    ?.filter((task) => checked[task.project.id])
    .filter((task) =>
      task.taskName.toLowerCase().includes(search.toLowerCase())
    );

  // decide what to render
  let content = null;

  if (isLoading && !isError) {
    content = <p>Loading...</p>;
  }

  if (!isLoading && isError) {
    content = <p>There was an error</p>;
  }

  if (!isLoading && !isError && filteredTasks?.length === 0) {
    content = <p>No tasks found</p>;
  }

  if (!isLoading && !isError && filteredTasks?.length > 0) {
    content = filteredTasks.map((task) => {
      const { date, month } = dateToArr(task.deadline);

      return (
        <SingleTask
          key={task.id}
          id={task.id}
          color={task.project.colorClass}
          task={task.project.projectName}
          title={task.taskName}
          date={date}
          month={month}
          image={task.teamMember.avatar}
          name={task.teamMember.name}
          status={task.status}
        />
      );
    });
  }

  return <div className="lws-task-list">{content}</div>;
};

export default TaskList;
